<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{"LOGIN.MESSAGE" | translate}}</p>
<app-button (click)="authenticate()" label="{{'LOGIN.BUTTON' | translate}}"></app-button>

